var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details-list"},[_vm._l((Object.keys(_vm.fieldRenderers)),function(fieldName){return [(_vm.object[fieldName])?_c(_vm.fieldRenderers[fieldName],{key:fieldName,tag:"component",attrs:{"value":_vm.object[fieldName]}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }